import { render, staticRenderFns } from "./Academic.vue?vue&type=template&id=67b31187&scoped=true&"
import script from "./Academic.vue?vue&type=script&lang=js&"
export * from "./Academic.vue?vue&type=script&lang=js&"
import style0 from "./Academic.vue?vue&type=style&index=0&id=67b31187&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b31187",
  null
  
)

export default component.exports